import { useQuery } from '@tanstack/react-query';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';
import { IGetPublicStatusParams } from '../types';

interface IUseGetLinkPublicStatus extends IGetPublicStatusParams {
  enabled: boolean;
}

export const useGetLinkPublicStatus = ({ id, enabled }: IUseGetLinkPublicStatus) => {
  return useQuery({
    queryKey: businessPlanQueryKeys.businessPlanPublicStatus(id),
    queryFn: () => BusinessPlanApi.getLinkPublicStatus({ id }),
    enabled,
  });
};
